import styled from 'styled-components';

import { Avatar } from '../../../../../cdl/Avatar/Avatar';
import { StyledDefaultHeaderCell } from '../../../../../cdl/TableBuilder/components/StyledDefaultHeaderCell';
import { Text } from '../../../../../cdl/Text/Text';
import { Tooltip } from '../../../../../cdl/Tooltip/Tooltip';
import { SupplierInfoDatasheet } from '../../../../../common/CoreDataPopup/SupplierInfoPopup';
import { InfoPopover } from '../../../../../common/InfoPopover/InfoPopover';
import { Box } from '../../../../../common/ui/Box';
import { theme } from '../../../../../common/ui/theme';
import type { OrderModel } from '../../../../model/OrderModel';
import { OfferCardContextProvider } from '../../OfferCard/components/OfferCardContextProvider';
import { OfferStatus } from '../../OfferCard/components/OfferStatus';
import type { LineItemComparisonColumn } from '../types/LineItemComparisonColumn';
import { useIsTruncated } from '../useIsTruncated';

const SupplierHeaderCell = styled(StyledDefaultHeaderCell)`
    vertical-align: top;
`;

const SupplierHeaderContent = styled.div`
    display: grid;
    grid-template-columns: auto minmax(0, 1fr);
    align-items: center;
    column-gap: ${theme.space[8]};
    row-gap: ${theme.space[8]};
    min-width: 0;
    width: 100%;
    text-align: left;
`;

const TruncatedText = styled(Text)`
    display: block;
    min-width: 0;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
`;

interface SupplierHeaderProps {
    column: LineItemComparisonColumn;
    order: OrderModel;
}

export const SupplierHeader = ({ column, order }: SupplierHeaderProps) => {
    const offer = column.offer;
    const { ref: supplierNameRef, isTruncated: isSupplierNameTruncated } = useIsTruncated<HTMLSpanElement>(
        column.supplierName
    );
    const supplierName = (
        <TruncatedText ref={supplierNameRef} variant="body" fontWeight={600}>
            {column.supplierName}
        </TruncatedText>
    );

    return (
        <SupplierHeaderCell textAlign="right">
            <OfferCardContextProvider offer={offer} order={order}>
                <SupplierHeaderContent>
                    <Avatar name={column.supplierName} imageUrl={offer.supplier.supplierGroup.logo?.url} size="small" />
                    <Box display="flex" alignItems="center" gap={4} minWidth={0}>
                        {isSupplierNameTruncated ? (
                            <Tooltip label={column.supplierName} side="top" align="center" showArrow>
                                {supplierName}
                            </Tooltip>
                        ) : (
                            supplierName
                        )}
                        {offer.isSpot() ? (
                            <InfoPopover align="start" width="360px">
                                <Box padding={16} onClick={(event) => event.stopPropagation()}>
                                    <SupplierInfoDatasheet supplier={offer.supplier} />
                                </Box>
                            </InfoPopover>
                        ) : null}
                    </Box>
                    <Box gridColumn="1 / -1">
                        <OfferStatus />
                    </Box>
                </SupplierHeaderContent>
            </OfferCardContextProvider>
        </SupplierHeaderCell>
    );
};
